import { Link } from 'react-router-dom';

export default function Footer() {
  const currentYear = new Date().getFullYear();

  return (
    <footer className="bg-gradient-to-br from-[#A7D676]/10 to-[#76C7E1]/10">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-12">
        <div className="grid grid-cols-1 md:grid-cols-4 gap-8">
          <div className="col-span-1 md:col-span-2">
            <img
              src="https://static.readdy.ai/image/aec91cb01fdf30f00658c017aec0d8c9/fbe82816bfa2944cd2cddb1856f203c2.png"
              alt="飛翠ロゴ"
              className="h-12 w-auto mb-4"
            />
            <p className="text-sm text-gray-600 leading-relaxed">
              飛翠は、関東圏で暮らしを支える<br />
              トータルサポート企業です。<br />
              出張買取から家財撤去、ハウスクリーニング、<br />
              家電修理、リフォームまで幅広く対応いたします。
            </p>
          </div>

          <div>
            <h3 className="text-sm font-bold text-gray-800 mb-4">サービス</h3>
            <ul className="space-y-2">
              <li>
                <Link to="/services" className="text-sm text-gray-600 hover:text-[#A7D676] transition-colors cursor-pointer">
                  出張買取
                </Link>
              </li>
              <li>
                <Link to="/services" className="text-sm text-gray-600 hover:text-[#A7D676] transition-colors cursor-pointer">
                  家財撤去
                </Link>
              </li>
              <li>
                <Link to="/services" className="text-sm text-gray-600 hover:text-[#A7D676] transition-colors cursor-pointer">
                  ハウスクリーニング
                </Link>
              </li>
              <li>
                <Link to="/services" className="text-sm text-gray-600 hover:text-[#A7D676] transition-colors cursor-pointer">
                  家電修理
                </Link>
              </li>
              <li>
                <Link to="/services" className="text-sm text-gray-600 hover:text-[#A7D676] transition-colors cursor-pointer">
                  リフォーム
                </Link>
              </li>
            </ul>
          </div>

          <div>
            <h3 className="text-sm font-bold text-gray-800 mb-4">会社情報</h3>
            <ul className="space-y-2">
              <li>
                <Link to="/about" className="text-sm text-gray-600 hover:text-[#A7D676] transition-colors cursor-pointer">
                  会社概要
                </Link>
              </li>
              <li>
                <Link to="/faq" className="text-sm text-gray-600 hover:text-[#A7D676] transition-colors cursor-pointer">
                  よくある質問
                </Link>
              </li>
              <li>
                <Link to="/contact" className="text-sm text-gray-600 hover:text-[#A7D676] transition-colors cursor-pointer">
                  お問い合わせ
                </Link>
              </li>
            </ul>
          </div>
        </div>

        <div className="border-t border-gray-300 mt-8 pt-8 flex flex-col md:flex-row justify-between items-center">
          <p className="text-sm text-gray-600">
            © {currentYear} 飛翠（ひすい）All rights reserved.
          </p>
          <a
            href="https://readdy.ai/?ref=logo"
            target="_blank"
            rel="noopener noreferrer"
            className="text-sm text-gray-500 hover:text-[#A7D676] transition-colors mt-4 md:mt-0 cursor-pointer"
          >
            Powered by Readdy
          </a>
        </div>
      </div>
    </footer>
  );
}
